/**
 * Patrol 360° asset hotspot marker icons (public/images/patrol-hotspots).
 */

const PUBLIC_URL = process.env.PUBLIC_URL ?? "";

function patrolHotspotPublicPath(relativePath) {
  const base = String(PUBLIC_URL).replace(/\/$/, "");
  const path = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
  return `${base}${path}`;
}

const PATROL_HOTSPOT_ICON_BASE = patrolHotspotPublicPath("/images/patrol-hotspots");

export const PATROL_API_URL_GREEN_ICON = `${PATROL_HOTSPOT_ICON_BASE}/api_url_green.png`;
export const PATROL_API_URL_RED_ICON = `${PATROL_HOTSPOT_ICON_BASE}/api_url_red.png`;
export const PATROL_API_URL_YELLOW_ICON = `${PATROL_HOTSPOT_ICON_BASE}/api_url_yellow.png`;

/** @type {Record<string, string>} */
const PATROL_HOTSPOT_ICON_BY_TYPE = {
  image: `${PATROL_HOTSPOT_ICON_BASE}/image.png`,
  pdf: `${PATROL_HOTSPOT_ICON_BASE}/pdf.png`,
  website: `${PATROL_HOTSPOT_ICON_BASE}/website.png`,
  youtube: `${PATROL_HOTSPOT_ICON_BASE}/youtube.png`,
  camera: `${PATROL_HOTSPOT_ICON_BASE}/camera.png`,
  text: `${PATROL_HOTSPOT_ICON_BASE}/text.png`,
  api_url: PATROL_API_URL_GREEN_ICON,
};

const PATROL_HOTSPOT_DEFAULT_ICON = `${PATROL_HOTSPOT_ICON_BASE}/default.png`;

/**
 * @param {string | undefined | null} showType
 * @returns {string}
 */
export function getPatrolHotspotMarkerIconUrl(showType) {
  const key = String(showType ?? "")
    .trim()
    .toLowerCase();
  return PATROL_HOTSPOT_ICON_BY_TYPE[key] ?? PATROL_HOTSPOT_DEFAULT_ICON;
}

export const PATROL_HOTSPOT_LAYER_TOGGLE_ICON = PATROL_HOTSPOT_DEFAULT_ICON;
